import { useMutation } from 'react-query';
import { orgUnitApi } from '../../api';

const useDelete = () => {
  const mutation = useMutation((id: number): any => {
    return orgUnitApi.delete(id);
  });
  return mutation;
};

export default useDelete;
